/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Payload to update a member's role
 * @export
 * @interface UpdateMemberRoleRequest
 */
export interface UpdateMemberRoleRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateMemberRoleRequest
     */
    role: UpdateMemberRoleRequestRoleEnum;
}


/**
 * @export
 */
export const UpdateMemberRoleRequestRoleEnum = {
    Admin: 'admin',
    Member: 'member'
} as const;
export type UpdateMemberRoleRequestRoleEnum = typeof UpdateMemberRoleRequestRoleEnum[keyof typeof UpdateMemberRoleRequestRoleEnum];


/**
 * Check if a given object implements the UpdateMemberRoleRequest interface.
 */
export function instanceOfUpdateMemberRoleRequest(value: object): value is UpdateMemberRoleRequest {
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function UpdateMemberRoleRequestFromJSON(json: any): UpdateMemberRoleRequest {
    return UpdateMemberRoleRequestFromJSONTyped(json, false);
}

export function UpdateMemberRoleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateMemberRoleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'role': json['role'],
    };
}

export function UpdateMemberRoleRequestToJSON(json: any): UpdateMemberRoleRequest {
    return UpdateMemberRoleRequestToJSONTyped(json, false);
}

export function UpdateMemberRoleRequestToJSONTyped(value?: UpdateMemberRoleRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'role': value['role'],
    };
}

